import { MutationTree } from 'vuex';
import { ETagMutation } from './tag.constants';
import { ITagState } from './tag.types';
import { ITag } from '@lib-shared/types/Tag';

export const mutations: MutationTree<ITagState> = {
  [ETagMutation.SetTags](state: ITagState, tags: ITag[]) {
    state.tags = tags;
  },
  [ETagMutation.SetLoaded](state: ITagState, loaded: boolean) {
    state.loaded = loaded;
  },
  [ETagMutation.SetLoading](state: ITagState, loading: boolean) {
    state.loading = loading;
  },
  [ETagMutation.AddTag](state: ITagState, newTag: ITag) {
    state.tags = [...state.tags, newTag];
  },
};
